//console.log('tracking-events loaded');

window.dataLayer = window.dataLayer || [];

function pushEvent(eventName, ecommerceData) {
  window.dataLayer.push({
    event: eventName,
    ecommerce: ecommerceData
  });
}

// 🔥 VIEW ITEM (product page)
if (window.productData && window.selectedVariant) {
  pushEvent('view_item', {
    currency: 'USD',
    value: parseFloat(window.selectedVariant.price) / 100,
    items: [{
      item_id: window.selectedVariant.sku || window.selectedVariant.id,
      item_name: window.productData.title,
      item_brand: window.productData.vendor,
      item_category: window.productData.type,
      item_variant: window.selectedVariant.title,
      price: parseFloat(window.selectedVariant.price) / 100,
      item_group_id: window.productData.id
    }]
  });
}
document.addEventListener('submit', function(e) {
  const form = e.target;

  if (form.matches('form[action*="/cart/add"]')) {
    setTimeout(() => {
      try {
        const variantId = form.querySelector('[name="id"]').value;

        // find variant from productData
        const variant = window.productData.variants.find(v => v.id == variantId);

        if (!variant) return;

        window.dataLayer.push({
          event: 'add_to_cart',
          ecommerce: {
            currency: 'USD',
            value: variant.price / 100,
            items: [{
              item_id: variant.sku || variant.id,
              item_name: window.productData.title,
              item_brand: window.productData.vendor,
              item_category: window.productData.type,
              item_variant: variant.title,
              price: variant.price / 100,
              quantity: 1,
              item_group_id: window.productData.id
            }]
          }
        });

        console.log('ATC fired', variant.sku);

      } catch (err) {
        console.error('ATC error', err);
      }
    }, 200); // slight delay to ensure form is processed
  }
});